module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    class: _vm.loadDecorated.day
  }, [(_vm.canBeMoved) ? _c('a', {
    staticClass: "move",
    attrs: {
      "href": "#"
    }
  }, [_c('i', {
    staticClass: "fa fa-bars"
  })]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "data-vv-scope": _vm.validationScope
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-4 col-lg-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Load ID")]), _c('br'), _vm._v("\n              " + _vm._s(_vm.load.reference_number ? _vm.load.reference_number : '–') + "\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2 form-group",
    class: {
      'has-error': _vm.errors.has('loading_date', _vm.validationScope)
    }
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', {
    class: {
      'text-danger': _vm.errors.has('loading_date', _vm.validationScope)
    }
  }, [_vm._v("Loading Date")]), _vm._v(" "), _c('date-range', {
    attrs: {
      "max-date": _vm.deliveryDateAsMoment,
      "single-date-picker": true,
      "opens": "right",
      "drops": "up",
      "placeholder": "00/00/0000",
      "name": "loading_date"
    },
    model: {
      value: (_vm.loadingDate),
      callback: function($$v) {
        _vm.loadingDate = $$v
      },
      expression: "loadingDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Loading Time")]), _c('br'), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.flatPickerConfig,
      "placeholder": "9:00 AM"
    },
    model: {
      value: (_vm.loadingTime),
      callback: function($$v) {
        _vm.loadingTime = $$v
      },
      expression: "loadingTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Delivery Date")]), _vm._v(" "), _c('date-range', {
    attrs: {
      "min-date": _vm.loadingDateAsMoment,
      "single-date-picker": true,
      "opens": "right",
      "drops": "up",
      "placeholder": "00/00/0000",
      "name": "delivery_date"
    },
    model: {
      value: (_vm.deliveryDate),
      callback: function($$v) {
        _vm.deliveryDate = $$v
      },
      expression: "deliveryDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Delivery Time")]), _vm._v(" "), _c('flat-pickr', {
    staticClass: "form-control",
    attrs: {
      "config": _vm.flatPickerConfig,
      "placeholder": "11:00 AM"
    },
    model: {
      value: (_vm.deliveryTime),
      callback: function($$v) {
        _vm.deliveryTime = $$v
      },
      expression: "deliveryTime"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2 form-group"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.loadSize),
      expression: "loadSize"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.loadSize)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.loadSize = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("/t")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("\n                Rate\n                "), _c('span', {
    class: {
      'text-success': _vm.isProfitableLoadForArrow, 'text-danger': _vm.isNotProfitableLoadForArrow
    },
    attrs: {
      "title": _vm.perTonneDifference
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.arrowProfitAsMoney) + "\n                ")])])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rate),
      expression: "rate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.rate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.rate = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-8 col-xl-4 form-group",
    class: {
      'has-error': _vm.errors.has('carrier', _vm.validationScope)
    }
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', {
    class: {
      'text-danger': _vm.errors.has('carrier', _vm.validationScope)
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "carrier",
      "options": _vm.carrierOptions,
      "fetch-results": _vm.fetchCarrierResults,
      "placeholder": "–"
    },
    model: {
      value: (_vm.carrier),
      callback: function($$v) {
        _vm.carrier = $$v
      },
      expression: "carrier"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Rego")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "truck",
      "options": _vm.truckOptions,
      "disabled": _vm.noCarrierSelected,
      "fetch-results": _vm.fetchTruckResults,
      "placeholder": "–"
    },
    model: {
      value: (_vm.truck),
      callback: function($$v) {
        _vm.truck = $$v
      },
      expression: "truck"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Driver")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "driver",
      "options": _vm.driverOptions,
      "disabled": _vm.noTruckSelected,
      "fetch-results": _vm.fetchDriverResults,
      "placeholder": "–"
    },
    model: {
      value: (_vm.driver),
      callback: function($$v) {
        _vm.driver = $$v
      },
      expression: "driver"
    }
  })], 1), _vm._v(" "), (_vm.hasDevice) ? _c('span', {
    staticClass: "help-block device-help-block"
  }, [_vm._v("Driver will be notified")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-4 col-xl-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Configuration")]), _vm._v(" "), _c('selectize', {
    attrs: {
      "name": "configuration",
      "options": _vm.configurationOptions,
      "disabled": _vm.noTruckSelected,
      "placeholder": "–"
    },
    model: {
      value: (_vm.truckConfiguration),
      callback: function($$v) {
        _vm.truckConfiguration = $$v
      },
      expression: "truckConfiguration"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isPlannedLoad),
      expression: "isPlannedLoad"
    }],
    staticClass: "col-xs-6 col-sm-4 col-xl-2"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Status")]), _c('br'), _vm._v(" "), (_vm.requestWasSent) ? _c('span', {
    staticClass: "text-info"
  }, [_vm._v("Request Sent")]) : (_vm.requestWasDeclined) ? _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("Request Declined")]) : (_vm.isPlannedLoad) ? _c('span', {
    staticClass: "text-info"
  }, [_vm._v("Planning")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-8 col-lg-10"
  }, [_c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Driver Notes")]), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "btn-toolbar pull-right"
  }, [(_vm.canDeleteLoad) ? _c('ladda-button', {
    staticClass: "btn btn-circle-sm",
    attrs: {
      "disabled": _vm.aboutToBeUpdated,
      "on-click": _vm.handleDeleteLoad,
      "type": "danger",
      "title": "Delete Load"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-trash-alt"
  })]) : _vm._e(), _vm._v(" "), (_vm.canDuplicateLoad) ? _c('ladda-button', {
    staticClass: "btn btn-circle-sm",
    attrs: {
      "disabled": _vm.aboutToBeUpdated,
      "on-click": _vm.handleDuplicateLoad,
      "type": "info",
      "title": "Duplicate Load"
    }
  }, [_c('i', {
    staticClass: "far fa-copy"
  })]) : _vm._e(), _vm._v(" "), (_vm.canRequestLoad) ? _c('ladda-button', {
    staticClass: "btn btn-circle-sm",
    attrs: {
      "disabled": _vm.aboutToBeUpdated,
      "on-click": _vm.handleSendRequest,
      "type": "info",
      "title": "Send Load Request"
    }
  }, [_c('i', {
    staticClass: "fas fa-paper-plane"
  })]) : _vm._e(), _vm._v(" "), (_vm.canConfirmLoad) ? _c('ladda-button', {
    staticClass: "btn btn-circle-sm",
    attrs: {
      "disabled": _vm.aboutToBeUpdated,
      "on-click": _vm.handleConfirmLoad,
      "type": "info",
      "title": "Confirm Load"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-check"
  })]) : _vm._e(), _vm._v(" "), (_vm.canAddToLoadPlan) ? _c('ladda-button', {
    staticClass: "btn btn-circle-sm",
    attrs: {
      "disabled": _vm.aboutToBeUpdated,
      "on-click": _vm.handleAddToPlan,
      "type": "info",
      "title": "Add to Plan"
    }
  }, [_c('i', {
    staticClass: "fa fa-fw fa-plus"
  })]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInUp",
      "leave-active-class": "animated fadeOutDown"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.changesSaved),
      expression: "changesSaved"
    }],
    staticClass: "col-lg-12 text-right"
  }, [_c('div', {
    staticClass: "margin-20"
  }), _vm._v(" "), _c('span', {
    staticClass: "text-success"
  }, [_c('i', {
    staticClass: "fa fa-check"
  }), _vm._v(" Changes Saved")])])])], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "material-details"
  }, [_c('strong', [_vm._v("Load Size")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../~/vue-loader/lib/template-compiler?{"id":"data-v-3d9e3791"}!../~/vue-loader/lib/selector.js?type=template&index=0!./src/components/jobs/loads/PlannedLoad.vue
// module id = 970
// module chunks = 0